import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { GigletsBookV1, NewGigletsBookV1 } from '@ilteducation/content-registry-types';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import { defaultSubscriptions } from '@/foundations/helpers/defaultSubscriptions';
import { defaultRealms } from '@/foundations/helpers/defaultRealms';
import useMediaFormFeature from '@/comp/use-media-form-feature';

type Props = {
  id?: string;
  title: string;
  item?: GigletsBookV1 | NewGigletsBookV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: GigletsBookV1 | NewGigletsBookV1;
}


const availableMarkets = ref(defaultRealms);
const availableSubscriptions = ref(defaultSubscriptions);
const notEmptyRule = ref([(val: any) => (val || '').length > 0 || 'This field is required']);
const trimmedString = ref([
  (val: string) => !/^\s+|\s+$/.test(val) || 'Leading or trailing whitespaces are not allowed',
]);
const trimmedString1 = (value: string) => /^\s+|\s+$/.test(value) || 'Leading or trailing whitespaces are not allowed';

const { uploadMedia, saveButtonAvailable, isCloneMode } = useMediaFormFeature(props.item);

return { __sfc: true,props, availableMarkets, availableSubscriptions, notEmptyRule, trimmedString, trimmedString1, uploadMedia, saveButtonAvailable, isCloneMode, DisableableButton }
}

})